import {
  CREATE_LOCATION,
  LOCATIONS_RECIBIDAS,
  SET_LOCATION,
  SET_PROPIEDAD_LOCATION,
} from "../types";
import { SET_CITIES, SET_COUNTRIES, SET_STATES } from "../types/locations";

const schema = {
  description: "",
  address: "",
};

const LocationsReducer = (state, { type, payload }) => {
  switch (type) {
    case SET_COUNTRIES:
      return { ...state, countries: payload };
    case SET_STATES:
      return { ...state, states: payload };
    case SET_CITIES:
      return { ...state, cities: payload };
    case LOCATIONS_RECIBIDAS:
      return { ...state, locations: payload };
    case SET_LOCATION:
      return { ...state, location: payload };
    case SET_PROPIEDAD_LOCATION:
      const location = { ...state.location };
      const { key, value } = payload;
      location[key] = value;
      return { ...state, location };
    case CREATE_LOCATION:
      return { ...state, location: schema };
    default:
      return { ...state };
  }
};

export default LocationsReducer;
